import * as ambassadorWixEventsV1Rsvp from './events-v1-rsvp-rsvp.http.js';
import * as ambassadorWixEventsV1RsvpTypes from './events-v1-rsvp-rsvp.types.js';
import * as ambassadorWixEventsV1RsvpUniversalTypes from './events-v1-rsvp-rsvp.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listRsvp(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEventsV1RsvpUniversalTypes.ListRsvpRequest,
  ambassadorWixEventsV1RsvpTypes.ListRsvpRequest,
  ambassadorWixEventsV1RsvpUniversalTypes.ListRsvpResponse,
  ambassadorWixEventsV1RsvpTypes.ListRsvpResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Rsvp.listRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/rsvp',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryRsvp(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1RsvpUniversalTypes.QueryRsvpRequest,
  ambassadorWixEventsV1RsvpTypes.QueryRsvpRequest,
  ambassadorWixEventsV1RsvpUniversalTypes.QueryRsvpResponse,
  ambassadorWixEventsV1RsvpTypes.QueryRsvpResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Rsvp.queryRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/rsvp/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getRsvp(): __PublicMethodMetaInfo<
  'GET',
  { rsvpId: string },
  ambassadorWixEventsV1RsvpUniversalTypes.GetRsvpRequest,
  ambassadorWixEventsV1RsvpTypes.GetRsvpRequest,
  ambassadorWixEventsV1RsvpUniversalTypes.GetRsvpResponse,
  ambassadorWixEventsV1RsvpTypes.GetRsvpResponse
> {
  const payload = { rsvpId: ':rsvpId' } as any;

  const getRequestOptions = ambassadorWixEventsV1Rsvp.getRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/rsvp/{rsvpId}',
    pathParams: { rsvpId: 'rsvpId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createRsvp(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1RsvpUniversalTypes.CreateRsvpRequest,
  ambassadorWixEventsV1RsvpTypes.CreateRsvpRequest,
  ambassadorWixEventsV1RsvpUniversalTypes.CreateRsvpResponse,
  ambassadorWixEventsV1RsvpTypes.CreateRsvpResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Rsvp.createRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/rsvp',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateRsvp(): __PublicMethodMetaInfo<
  'PATCH',
  { rsvpId: string },
  ambassadorWixEventsV1RsvpUniversalTypes.UpdateRsvpRequest,
  ambassadorWixEventsV1RsvpTypes.UpdateRsvpRequest,
  ambassadorWixEventsV1RsvpUniversalTypes.UpdateRsvpResponse,
  ambassadorWixEventsV1RsvpTypes.UpdateRsvpResponse
> {
  const payload = { rsvpId: ':rsvpId' } as any;

  const getRequestOptions = ambassadorWixEventsV1Rsvp.updateRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/rsvp/{rsvpId}',
    pathParams: { rsvpId: 'rsvpId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateRsvp(): __PublicMethodMetaInfo<
  'PATCH',
  {},
  ambassadorWixEventsV1RsvpUniversalTypes.BulkUpdateRsvpRequest,
  ambassadorWixEventsV1RsvpTypes.BulkUpdateRsvpRequest,
  ambassadorWixEventsV1RsvpUniversalTypes.BulkUpdateRsvpResponse,
  ambassadorWixEventsV1RsvpTypes.BulkUpdateRsvpResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Rsvp.bulkUpdateRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/rsvp',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteRsvp(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixEventsV1RsvpUniversalTypes.DeleteRsvpRequest,
  ambassadorWixEventsV1RsvpTypes.DeleteRsvpRequest,
  ambassadorWixEventsV1RsvpUniversalTypes.DeleteRsvpResponse,
  ambassadorWixEventsV1RsvpTypes.DeleteRsvpResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Rsvp.deleteRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/rsvp',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function checkInRsvp(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEventsV1RsvpUniversalTypes.CheckInRsvpRequest,
  ambassadorWixEventsV1RsvpTypes.CheckInRsvpRequest,
  ambassadorWixEventsV1RsvpUniversalTypes.CheckInRsvpResponse,
  ambassadorWixEventsV1RsvpTypes.CheckInRsvpResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixEventsV1Rsvp.checkInRsvp(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/rsvp/check-in',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteRsvpCheckIn(): __PublicMethodMetaInfo<
  'DELETE',
  {},
  ambassadorWixEventsV1RsvpUniversalTypes.DeleteRsvpCheckInRequest,
  ambassadorWixEventsV1RsvpTypes.DeleteRsvpCheckInRequest,
  ambassadorWixEventsV1RsvpUniversalTypes.DeleteRsvpCheckInResponse,
  ambassadorWixEventsV1RsvpTypes.DeleteRsvpCheckInResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEventsV1Rsvp.deleteRsvpCheckIn(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/rsvp/check-in',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Rsvp as RsvpOriginal,
  FormResponse as FormResponseOriginal,
  InputValue as InputValueOriginal,
  FormattedAddress as FormattedAddressOriginal,
  Address as AddressOriginal,
  AddressStreetOneOf as AddressStreetOneOfOriginal,
  StreetAddress as StreetAddressOriginal,
  AddressLocation as AddressLocationOriginal,
  Subdivision as SubdivisionOriginal,
  SubdivisionType as SubdivisionTypeOriginal,
  SubdivisionTypeWithLiterals as SubdivisionTypeWithLiteralsOriginal,
  StandardDetails as StandardDetailsOriginal,
  RsvpStatus as RsvpStatusOriginal,
  RsvpStatusWithLiterals as RsvpStatusWithLiteralsOriginal,
  Guest as GuestOriginal,
  CheckIn as CheckInOriginal,
  ListRsvpRequest as ListRsvpRequestOriginal,
  RsvpFieldset as RsvpFieldsetOriginal,
  RsvpFieldsetWithLiterals as RsvpFieldsetWithLiteralsOriginal,
  RsvpTag as RsvpTagOriginal,
  RsvpTagWithLiterals as RsvpTagWithLiteralsOriginal,
  ListRsvpResponse as ListRsvpResponseOriginal,
  FacetCounts as FacetCountsOriginal,
  RsvpFacets as RsvpFacetsOriginal,
  RsvpFacetCounts as RsvpFacetCountsOriginal,
  Counts as CountsOriginal,
  QueryRsvpRequest as QueryRsvpRequestOriginal,
  QueryRsvpResponse as QueryRsvpResponseOriginal,
  GetRsvpRequest as GetRsvpRequestOriginal,
  GetRsvpResponse as GetRsvpResponseOriginal,
  CreateRsvpRequest as CreateRsvpRequestOriginal,
  ModificationOptions as ModificationOptionsOriginal,
  CreateRsvpResponse as CreateRsvpResponseOriginal,
  CalendarLinks as CalendarLinksOriginal,
  RsvpCreated as RsvpCreatedOriginal,
  OnlineConferencingLogin as OnlineConferencingLoginOriginal,
  UpdateRsvpRequest as UpdateRsvpRequestOriginal,
  UpdateRsvpResponse as UpdateRsvpResponseOriginal,
  RsvpUpdated as RsvpUpdatedOriginal,
  BulkUpdateRsvpRequest as BulkUpdateRsvpRequestOriginal,
  BulkUpdateRsvpResponse as BulkUpdateRsvpResponseOriginal,
  DeleteRsvpRequest as DeleteRsvpRequestOriginal,
  DeleteRsvpResponse as DeleteRsvpResponseOriginal,
  RsvpDeleted as RsvpDeletedOriginal,
  CheckInRsvpRequest as CheckInRsvpRequestOriginal,
  CheckInRsvpResponse as CheckInRsvpResponseOriginal,
  DeleteRsvpCheckInRequest as DeleteRsvpCheckInRequestOriginal,
  DeleteRsvpCheckInResponse as DeleteRsvpCheckInResponseOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './events-v1-rsvp-rsvp.types.js';
